"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["BACK_END_ERROR"] = "BackEndError";
    ErrorCode["NOT_FOUND"] = "NotFound";
    ErrorCode["INVALID_CONTRACT"] = "InvalidContract";
    ErrorCode["INVALID_STATUS_CHECK_KEY"] = "InvalidStatusCheckKey";
    ErrorCode["BAD_REQUEST"] = "BadRequest";
    ErrorCode["BAD_GATEWAY"] = "BadGateway";
    ErrorCode["MULTIPLE_CHOICES"] = "MultipleChoices";
    ErrorCode["DATA_INVALID"] = "DataInvalid";
    ErrorCode["TOKEN_INVALID"] = "TokenInvalid";
    ErrorCode["AUTH_ERROR"] = "AuthError";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
//# sourceMappingURL=ErrorCode.js.map